import { useTranslation } from "react-i18next";
import Label, { statusText } from ".";
import { useRecordContext } from "react-admin";

export const mapStatus = {
  ACTIVE: {
    state: "success",
    text: "ACTIVE",
    original: "ACTIVE",
  },
  INACTIVE: {
    state: "error",
    text: "INACTIVE",
    original: "INACTIVE",
  },
  CREATED: {
    state: "info",
    text: "CREATED",
    original: "CREATED",
  },
  AUTHORISATION: {
    state: "info",
    text: "PAYMENT AUTHORISATION",
    original: "AUTHORISATION",
  },
  CAPTURED: {
    state: "info",
    text: "PAYMENT CAPTURED",
    original: "CAPTURED",
  },
  CAPTURE: {
    state: "info",
    text: "PAYMENT CAPTURED",
    original: "CAPTURE",
  },
  DONE: {
    state: "success",
    text: "SUCCESS",
    original: "done",
  },
  TRANSACTION_PROCESS: {
    state: "info",
    text: "TRANSACTION PROCESS",
    original: "transaction_process",
  },
  TX_PROCESSING: {
    state: "info",
    text: "TRANSACTION BLOCKCHAIN IN PROGRESS",
    original: "tx_processing",
  },
  PENDING: {
    state: "info",
    text: "PENDING",
    original: "tx_pending",
  },
  TX_PENDING: {
    state: "info",
    text: "TRANSACTION PENDING",
    original: "tx_pending",
  },
  UNDERPAID: {
    state: "warning",
    text: "UNDERPAID",
    original: "UNDERPAID",
  },
  OVERPAID_REFUNDING: {
    state: "warning",
    text: "OVERPAID - REFUNDING",
    original: "OVERPAID_REFUNDING",
  },
  SUCCESS: {
    state: "success",
    text: "SUCCESS",
    original: "success",
  },
  KYT_PENDING: {
    state: "info",
    text: "KYT PENDING",
    original: "KYT_PENDING",
  },
  KYT_REJECTED: {
    state: "error",
    text: "KYT REJECTED",
    original: "KYT_REJECTED",
  },
  CANCELLED: {
    state: "secondary",
    text: "CANCELLED",
    original: "CANCELLED",
  },
  ERROR: {
    state: "error",
    text: "ERROR",
    original: "error",
  },
  FAILED: {
    state: "error",
    text: "FAILED",
    original: "failed",
  },
  EXPIRED: {
    state: "error",
    text: "EXPIRED",
    original: "EXPIRED",
  },
  CLOSED: {
    state: "info",
    text: "CLOSED",
    original: "CLOSED",
  },
  REFUND: {
    state: "success",
    text: "REFUND",
    original: "REFUND",
  },
  NOT_ENOUGH_RECEIVED: {
    state: "error",
    text: "NOT ENOUGH RECEIVED",
    original: "not_enough_received",
  },
  SUCCESS_TOO_MUCH_RECEIVED: {
    state: "success",
    text: "SUCCESS TOO MUCH RECEIVED",
    original: "success_too_much_received",
  },
  ORDER_PAYMENT_TOO_MUCH_RECEIVED: {
    state: "success",
    text: "ORDER PAYMENT TOO MUCH RECEIVED",
    original: "order_payment_too_much_received",
  },
  TOO_MUCH_RECEIVED: {
    state: "info",
    text: "TOO MUCH RECEIVED",
    original: "too_much_received",
  },
  ACTIVATED: {
    state: "success",
    text: "ACTIVATED",
    original: "activated",
  },
  TRUE: {
    state: "success",
    text: "TRUE",
    original: "true",
  },
  FALSE: {
    state: "error",
    text: "FALSE",
    original: "false",
  },
  PENDING_APPROVAL: {
    state: "info",
    text: "PENDING APPROVAL",
    original: "PENDING_APPROVAL",
  },
  APPROVED: {
    state: "success",
    text: "APPROVED",
    original: "APPROVED",
  },
  BROADCASTED: {
    state: "info",
    text: "BROADCASTED",
    original: "BROADCASTED",
  },
  NEEDS_REVIEW: {
    state: "info",
    text: "NEEDS REVIEW",
    original: "NEEDS_REVIEW",
  },
  SENDING: {
    state: "info",
    text: "SENDING",
    original: "SENDING",
  },

};
export const StatusLabel = ({
  fontSize = "normal",
  statusField = "statusOrder",
  record: propRecord = null,
}) => {
  const { t }: { t: any } = useTranslation();
  const recordContext = useRecordContext();
  const record = propRecord || recordContext;

  // Si record n'existe pas, afficher un état par défaut sans modifier record
  const status = record?.[statusField]?.toUpperCase() || "ERROR";
  
  // Vérifier si le statut existe dans notre mapping, sinon utiliser ERROR
  const statusInfo = mapStatus[status] || mapStatus["ERROR"];
  const { text, state } = statusInfo;
  
  return (
    <Label color={state}>
      {t(statusText(text))}
    </Label>
  );
};

